/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SubCategoryPatch = {
    properties: {
        nameInternal: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        leagueCategory: {
            type: 'any-of',
            contains: [{
                type: 'LeagueCategoryEnum',
            }, {
                type: 'null',
            }],
        },
        isCup: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
        isMain: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
        name: {
            type: 'any-of',
            contains: [{
                type: 'TranslationPatch',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
